var map = {
	"./bonbons.png": 5731,
	"./hiking.jpg": 2164,
	"./logo.png": 3153,
	"./motorcycle.png": 8875,
	"./newprofile.jpg": 3889,
	"./profile.jpeg": 9914,
	"./profile.jpg": 2277,
	"./profile2_1.jpg": 9391,
	"./profile_square.jpg": 7715,
	"./research/airplane.png": 5438,
	"./research/airplane.svg": 562,
	"./research/diffusionmodel.png": 776,
	"./research/ect.png": 9350,
	"./research/image1-1.png": 6246,
	"./research/lorentz.png": 7790,
	"./research/normal form.jpg": 9915,
	"./research/triangulation.png": 2243,
	"./sunset.png": 5178
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;